import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { map } from 'rxjs';
import {
  AppLoadingOverlayComponent,
  DEFAULT_SPINNER_DELAY_MS,
} from './app-loading-overlay/app-loading-overlay.component';
import { RoutingLoadingService } from './routing-loading.service';

// Boot has nothing behind the veil to look at anyway, so the spinner waits longer there —
// long enough that a quick initial route never flashes one.
const BOOT_SPINNER_DELAY_MS = 500;

@Component({
  selector: 'dojo-app-loader',
  imports: [AppLoadingOverlayComponent],
  template: `
    <dojo-app-loading-overlay [show]="state.showFullScreenLoader" [spinnerDelayMs]="state.spinnerDelayMs" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLoaderComponent {
  constructor(private readonly routingLoadingService: RoutingLoadingService) {}

  readonly state = connectState({
    showFullScreenLoader: this.routingLoadingService.showFullScreenLoader$,
    spinnerDelayMs: this.routingLoadingService.isInitialRoutingLoading$.pipe(
      map((isInitialRoutingLoading) => (isInitialRoutingLoading ? BOOT_SPINNER_DELAY_MS : DEFAULT_SPINNER_DELAY_MS)),
    ),
  });
}
